import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

export interface ConfirmDialogData {
    title?: string;
    message?: string;
    confirmText?: string;
    cancelText?: string;
    type?: 'warning' | 'danger' | 'info' | 'success';
}

export interface DialogState {
    isOpen: boolean;
    data?: ConfirmDialogData;
}

@Injectable({
    providedIn: 'root'
})
export class ConfirmDialogService {
    private dialogStateSubject = new BehaviorSubject<DialogState>({ isOpen: false });
    public dialogState$ = this.dialogStateSubject.asObservable();

    private resultSubject = new Subject<boolean>();

    confirm(data: ConfirmDialogData): Promise<boolean> {
        this.dialogStateSubject.next({
            isOpen: true,
            data
        });

        // Reset the result subject for the new confirmation request
        this.resultSubject = new Subject<boolean>();

        return new Promise<boolean>((resolve) => {
            this.resultSubject.subscribe({
                next: (result) => {
                    resolve(result);
                }
            });
        });
    }

    close(confirmed: boolean) {
        this.dialogStateSubject.next({ isOpen: false });
        this.resultSubject.next(confirmed);
        this.resultSubject.complete();
    }
}
